export default "__VITE_ASSET__VwVJZv4m__"